export const EXPORT_TYPES = {
  GENERIC: 'genericExport',
  CHEMQUOTE: 'ChemQuote',
};

export const EXPORT_EVENTS = {
  error: 'EXPORT:exportError',
};

export const EXPORT_TEXTS = {
  busyInfoDialogButton: 'Ok',
  busyInfoDialogTitle: 'Export',
  busyInfoDialogText: 'Please cancel the previous Export job before you start a new one.',
  errorDialogTitle: 'Error',
  errorDialogConfirmText: 'Cancel',
  dailyLimitReachedTitle: 'Daily export limit reached',
  warningRangeHighBioactivityVisualizationTooltip:
    'Please click on target(s) or substance(s) to select them. Limit the selection by clicking on “limit to“ in the toolbar panel.',
};

export const EXPORT_TAB_EVENTS = {
  [EXPORT_TYPES.GENERIC]: {
    exportStarted: `${EXPORT_TYPES.GENERIC}:exportStarted`,
    cancel: `${EXPORT_TYPES.GENERIC}:exportCancel`,
    progressInfo: `${EXPORT_TYPES.GENERIC}:exportProgressInfo`,
    connectionError: `${EXPORT_TYPES.GENERIC}:exportConnectionError`,
  },
  [EXPORT_TYPES.CHEMQUOTE]: {
    exportStarted: `${EXPORT_TYPES.CHEMQUOTE}:exportStarted`,
    cancel: `${EXPORT_TYPES.CHEMQUOTE}:exportCancel`,
    progressInfo: `${EXPORT_TYPES.CHEMQUOTE}:exportProgressInfo`,
    connectionError: `${EXPORT_TYPES.CHEMQUOTE}:exportConnectionError`,
  },
};
